import { traceError } from "utils/traceContext";

export const isUsableUri = (uri) => {
	if (typeof uri !== "string") return false;

	const normalizedUri = uri.trim();
	return (
		normalizedUri !== "" && !/(^|\/)undefined(?:\/|$)/i.test(normalizedUri)
	);
};

// Falls back to the page's own URL when the backend omits a canonical, so
// indexable pages never render without a self-referential canonical tag
// (SF-20388).
export const getSelfReferentialCanonical = (canonical, baseUrl, pathname) =>
	canonical || `${baseUrl}${pathname}`;

export const ensureAbsoluteUrl = (url, baseUrl) => {
	if (!url || !baseUrl) return url;

	try {
		const parsedUrl = new URL(url);
		return `${baseUrl}${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
	} catch (error) {
		traceError(`ensureAbsoluteUrl failed for url: ${url}`, error);
		return url;
	}
};
